import * as React from "react";
import { Routes, Route } from "react-router-dom";
import ProjectSubmissionForm from "../Project/ProjectSubmissionForm";
import ProjectView from "../Project/ProjectView";
import AddPortfolioForm from "../AddPortfolioForm";
import AppLayout from "../AppLayout";
import ViewLectures from "../ViewLectures";
import AttendanceHistory from "../AttendanceHistory";
import StudentDashboardUi from "../StudentDashboard";
import StudentProfile from "../StudentProfile";
import FeeHistory from "../FeeHistory";
import AssetsSection from "../AssetsSection";
import Interview from "../interview";
import Ranking from "../Ranking/Ranking";

export default function userRoutes() {
  return (
    <Routes>
      {/* Layout Route */}
      <Route path="/" element={<AppLayout />}>
        {/* Nested Routes */}
        {/* <Route index element={<hrDashboard />} /> */}
        {/* <Route index element={<StudentList />} /> */}
        {/* <Route index element={<StudentDashboard />} /> */}
        <Route index element={<StudentDashboardUi />} />
        <Route path="feehistory/:id" element={<FeeHistory />} />
        <Route path="ranking" element={<Ranking />} />
        <Route path=":username" element={<StudentProfile />} />
        <Route path="projects" element={<ProjectView />} />
        <Route path="projects/add" element={<ProjectSubmissionForm />} />
        <Route path="resource" element={<AssetsSection />} />
        <Route path="add-portfolio" element={<AddPortfolioForm />} />
        <Route path="view-attendance" element={<AttendanceHistory />} />
        <Route path="view-attendance/:id" element={<AttendanceHistory />} />
        <Route path="lectures" element={<ViewLectures />} />
        <Route path="interview" element={<Interview />} />
        <Route
          path="*"
          element={<h1 className="text-primary">404 not found</h1>}
        />
      </Route>
    </Routes>
  );
}
